import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { AWS_URL } from "../../Constant";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const columns = [
  {
    field: "sno",
    headerName: "ID",
    width: 70,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "productName",
    headerName: "ProductName",
    width: 280,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "brand",
    headerName: "Brands",
    width: 130,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "barcode",
    headerName: "Barcode",
    width: 160,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  // {
  //   field: "mrp",
  //   headerName: "MRP",
  //   width: 120,
  //   headerClassName: "custom-header",
  //   headerAlign: "center",
  // },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 100,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "landingCost",
    headerName: "LandingCost",
    width: 120,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "gst",
    headerName: "GST%",
    type: "number",
    width: 100,
    headerClassName: "custom-header",
    headerAlign: "center",
  },

  {
    field: "model_number",
    headerName: "Model_number",
    width: 150,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  // {
  //   field: "cutoffprice",
  //   headerName: "Cutoff_Price",
  //   width: 130,
  //   headerClassName: "custom-header",
  //   headerAlign: "center",
  // },
];

const Stocks = () => {
  const [stocksData, setStocksData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterProductList, setFilterProductList] = useState([]);

  const fetchData = async () => {
    const jwtToken = Cookies.get("jwt_token");

    // const url = `https://ec2-13-235-112-81.ap-south-1.compute.amazonaws.com/getStoreData`;
    const url = `${AWS_URL}/getStoreData`

    const option = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    try {
      const response = await fetch(url, option);
      if (response.status === 200) {
        const data = await response.json();setStocksData(data["Products"]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFilterData = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const regex = new RegExp(searchQuery, "i"); // 'i' flag for case-insensitive matching

    const filterData = stocksData.filter((product) => {
      return (
        regex.test(product.brand) ||
        regex.test(product.barcode) ||
        regex.test(product.productName)
      );
    });
    setFilterProductList(filterData);
  }, [stocksData, searchQuery]);

  const getExportRows = () => {
    return filterProductList.map((item) => ({
      ID: item.sno,
      ProductName: item.productName,
      Brands: item.brand,
      Barcode: item.barcode,
      Quantity: item.quantity,
      LandingCost: item.landingCost,
      "GST%": item.gst,
      Model_number: item.model_number,
    }));
  };

  const downloadExcel = () => {
    const rows = getExportRows();
    if (!rows.length) {
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stocks");
    XLSX.writeFile(workbook, "stocks-report.xlsx");
  };

  const downloadPdf = () => {
    const rows = getExportRows();
    if (!rows.length) {
      return;
    }
    const doc = new jsPDF("l", "mm", "a4");
    autoTable(doc, {
      head: [Object.keys(rows[0] || {})],
      body: rows.map((row) => Object.values(row)),
      styles: { fontSize: 8 },
      margin: { top: 15 },
    });
    doc.save("stocks-report.pdf");
  };

  /*this function is for downloading the table data in excel format  */

  // const prepareDownload = () => {
  //   const csvHeaders = columns.map((column) => column.headerName);
  //   const csvRows = [csvHeaders.join(",")];
  //   csvRows.push(...stocksData.map((row) => Object.values(row).join(",")));
  //   const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
  //   const encodedUri = encodeURI(csvContent);
  //   const link = document.createElement("a");
  //   link.setAttribute("href", encodedUri);
  //   link.setAttribute("download", "stocks.csv");
  //   document.body.appendChild(link);
  //   link.click();
  // };

  return (
    <>
      <div className="gap-2 text-right mt-2 mr-2">
        <Link to={"/dashboard"}>
          <button className=" mr-2 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500  p-1 rounded-lg w-40 text-white text-lg  ">
            Dashboard
          </button>
        </Link>
      </div>

      <div className="p-3">
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 shadow-sm">
          <div className="mb-3 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <h1 className="font-bold text-xl text-slate-800">Stocks Details</h1>
            {/* <p className="text-sm text-slate-600">Arrange by date and export in one click</p> */}
          </div>

          <div className="flex flex-wrap items-end gap-3">
            <div className="flex flex-col">
              <label htmlFor="stocks-search" className="mb-1 text-xs font-semibold text-slate-600">
                Search
              </label>
              <input
                type="search"
                id="stocks-search"
                className="h-9 w-64 rounded-md border border-slate-300 bg-white px-2 text-sm placeholder:text-gray-500"
                onChange={handleFilterData}
                placeholder="Search product, brand, barcode"
              />
            </div>

            <div className="ml-auto flex gap-2">
              <button
                className="h-9 rounded-md bg-green-600 px-3 text-sm font-semibold text-white"
                onClick={downloadExcel}
              >
                Download Excel
              </button>
              <button
                className="h-9 rounded-md bg-red-600 px-3 text-sm font-semibold text-white"
                onClick={downloadPdf}
              >
                Download PDF
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{ height: 500, width: "100%", overflow: "auto" }}
        className="p-4"
      >
        <DataGrid
          sx={{
            ".MuiOutlinedInput-notchedOutline": { borderStyle: "none" },
            boxShadow: 2,
            border: 2,

            borderColor: "primary.light",
            "& .custom-header": {
              // fontSize: "h7.fontSize",
              fontWeight: "bold",
              fontSize: 16,
              color: "blue",
            },
            "& .MuiDataGrid-root, .MuiDataGrid-root ": {
              backgroundColor: "primary.main",
              color: "black",
            },
            "& .MuiDataGrid-colCell,  .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-sortIcon ": {
              backgroundColor: "red",
            },
            ".MuiDataGrid-cell": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
          rows={filterProductList}
          columns={columns}
          getRowId={(row) => row?.sno}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 20 },
            },
          }}
          pageSizeOptions={[5, 15]}
          checkboxSelection
          disableRowSelectionOnClick
        />
        {/* this is button for download the stocks */}

        {/* <Button
          onClick={prepareDownload}
          variant="contained"
          color="primary"
          style={{ margin: "10px" }}
        >
          Download Stocks
        </Button> */}
      </div>
    </>
  );
};

export default Stocks;
